import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';

import {takeUntilDestroy} from "take-until-destroy";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {SelfSchedulingService} from "../../../app-main/self.scheduling/services";
import {IntlServicePP} from "../../intl/services/intl.service";
import {WindowRef} from "@progress/kendo-angular-dialog";
import {PopupWindowService} from "../../services/popup.window.service";

@Component({
  selector: 'contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit, OnDestroy{
  public htmlContent: SafeHtml;

  constructor(public selfSchedulingService: SelfSchedulingService, private changeDetector: ChangeDetectorRef,
              private intlServicePP: IntlServicePP, private sanitizer: DomSanitizer, public window: WindowRef, public popupWindowService: PopupWindowService) {
  }

  ngOnInit(): void {
   this.selfSchedulingService.GetContactInfoHtml(this.intlServicePP.usedLanguage.languageKey).pipe(takeUntilDestroy(this))
     .subscribe((contactInfoHtml) => {
       if(contactInfoHtml) {
         this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(contactInfoHtml);
         this.changeDetector.markForCheck();
       }
     });
  }

  ngOnDestroy(): void {
  }
}
